import { render, staticRenderFns } from "./MInfiniteDetector.vue?vue&type=template&id=d10c1dc4"
import script from "./MInfiniteDetector.vue?vue&type=script&lang=js"
export * from "./MInfiniteDetector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports